import { SetActivityAvailabilityInput } from 'apollo/resolvers/activityAvailability/types';

export type AvailabilityChange = Omit<SetActivityAvailabilityInput, 'activityId'>;

export type DaysAvailability = Record<string, boolean>;

export const CANOPY_ACTIVITY_TYPE_ID = '3';

export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'DD-MM-YYYY';
